import React from 'react'


const SamplePage = () => {

 return (
    <div>test</div>
 );
}

export {SamplePage};